import React, { useState } from "react";
import {
  Container,
  Grid,
  ThemeProvider,
  Typography,
  makeStyles,
} from "@material-ui/core";
import Menu from "@material-ui/core/Menu";
import Button from "@material-ui/core/Button";
import { FilterList } from "@material-ui/icons";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import { colours, theme } from "../constants/theme";
import {
  FilterGroupContainer,
  FilterItems,
  FilterSelectionButton,
} from "../components-atoms";
import { TabPanel } from "../components-molecules";
import BackButton from "../components-atoms/BackButton";
import { textButtonHoverAndActive } from "../utils/styles/buttonStyles";

interface IFilterTypeList {
  title: string;
  text?: string;
  typeKey: string;
}

interface IProps {
  /** If user selects verticals, then verticals data will be loaded with checkboxes */
  /** If user selects categories, then category list will be loaded with checkboxes */
  setFilterTypeSelected: Function; // This part is helping choose which data (vertical, category etc...) should be loaded with checkboxes
  loading?: boolean;
  filterTypeList: Array<IFilterTypeList>; // This is the list of filter types (vertical, category, shop etc...)
  filterTypeDataDetails: Array<any>; // This is the data that loaded when user click one filter type
  addRemoveFilter: Function; // This function updates filter state of parent
  selectedFilters: any;
  setSelectedFilters: any;
}

export default function FilterButtonAndMenu(props: IProps) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [index, setIndex] = useState(0);
  const [activeFilterType, setActiveFilterType] = React.useState("");
  const { selectedFilters, setSelectedFilters } = props;
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const filterButtonCliked = (selectedFilterType) => {
    props.setFilterTypeSelected(selectedFilterType);
    setIndex(1);
  };
  const clearAll = () => {
    const selected = { ...selectedFilters };
    Object.keys(selectedFilters).forEach(m => {
      selected[m] = [];
    });
    setSelectedFilters(selected);
  };
  return (
    <div>
      <Button
        id="basic-button"
        aria-controls="basic-menu"
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        startIcon={<FilterList color="primary" />}
        onClick={handleClick}
        style={{
          marginLeft: 8,
          borderRadius: 8,
          backgroundColor: open ? colours.highEmphasis04 : undefined,
        }}
        className={classes.textButton}
      >
        <Typography
          variant="button"
          component="span"
          color="primary"
          className={classes.printButtonText}
        >
          Filter
        </Typography>
      </Button>
      <ClickAwayListener onClickAway={() => setIndex(0)}>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          style={{
            marginTop: 65,
            borderRadius: "12px",
            marginRight: "120px",
            width: "480px",
          }}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <Container className={classes.titleContainer}>
            {index ? (
              <Container className={classes.header}>
                <ThemeProvider theme={theme}>
                  <Grid container direction="row">
                    <Grid xs={2} item container>
                      <Grid
                        item
                        container
                        alignItems="center"
                        justifyContent="center"
                        xs={12}
                      >
                        <BackButton
                          onClick={() => setIndex(0)}
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      xs={5}
                      className={classes.headerOrderDetailSection}
                    >
                      <Grid item className={classes.verticalAlignTextArea}>
                        <Typography
                          variant="h5"
                          component="h1"
                          color="textPrimary"
                          className={classes.verticalAlignText}
                        >
                          {index === 0
                            ? "Filter"
                            : activeFilterType ?? "Filter"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </ThemeProvider>
              </Container>
            ) : (
              <Typography
                style={{ marginBottom: 15 }}
                variant="h6"
                component="span"
                color="textPrimary"
              >
                Filter
              </Typography>
            )}
          </Container>
          <Container className={classes.buttonContainer}>
            {index !== 1 && (
              <Button
                id="basic-button"
                aria-controls="basic-menu"
                aria-haspopup="true"
                onClick={() => clearAll()}
              >
                <Typography
                  variant="button"
                  component="span"
                  color="primary"
                  className={classes.buttonText}
                >
                  Clear all
                </Typography>
              </Button>
            )}
          </Container>
          <TabPanel value={index} index={0}>
            <Container className={classes.tabContainer}>
              {props?.filterTypeList &&
                props.filterTypeList.map((item: any, index: number) => (
                  <FilterSelectionButton
                    key={index}
                    title={item?.title ?? ""}
                    text={item?.text ?? ""}
                    onClick={() => {
                      filterButtonCliked(item?.typeKey);
                      setActiveFilterType(item?.typeKey);
                    }}
                  />
                ))}
            </Container>
          </TabPanel>
          <TabPanel value={index} index={1}>
            <Container className={classes.tabContainer}>
              {props?.filterTypeDataDetails &&
                props.filterTypeDataDetails.map((item: any, index: number) => (
                  <FilterGroupContainer
                    key={index}
                    letter={item?.[0] ?? ""}
                    count={item?.[1].length}
                  >
                    {item?.[1] &&
                      item?.[1].length !== 0 &&
                      item[1].map((itm: any, ind: number) => {
                        return (
                          <FilterItems
                            key={ind}
                            checked={
                              selectedFilters?.[activeFilterType] &&
                              selectedFilters[activeFilterType].includes(itm.Id)
                            }
                            onChange={(checked: boolean) => {
                              let fList =
                                selectedFilters &&
                                  selectedFilters?.[activeFilterType]
                                  ? [...selectedFilters[activeFilterType]]
                                  : [];
                              if (checked) {
                                !fList.includes(itm.Id) && fList.push(itm.Id);
                              } else {
                                fList = fList.filter(
                                  (it: any) => it !== itm.Id
                                );
                              }
                              const filtLatest = selectedFilters
                                ? { ...selectedFilters }
                                : {};
                              filtLatest[activeFilterType] = fList;
                              // If all filter types are empty then it should set filter as null
                              let condition = false;
                              props.filterTypeList.forEach((tp: any) => {
                                if (
                                  filtLatest?.[tp.typeKey] &&
                                  filtLatest[tp.typeKey].length > 0
                                )
                                  // console.log(filtLatest?.[tp.typeKey]) - removed
                                condition = true;
                              });
                              condition
                                ? setSelectedFilters({ ...filtLatest })
                                : setSelectedFilters(null);
                            }}
                            title={itm.Name || itm.Title}
                          />
                        );
                      })}
                  </FilterGroupContainer>
                ))}
              {/* <FilterGroupContainer letter="A" count={12}>
                <FilterItems title="aaa" />
                <FilterItems />
              </FilterGroupContainer>
              <FilterGroupContainer letter="A" count={12}>
                <FilterItems title="aaa" />
                <FilterItems />
              </FilterGroupContainer>
              <FilterGroupContainer letter="A" count={12}>
                <FilterItems title="aaa" />
                <FilterItems />
              </FilterGroupContainer>
              <FilterGroupContainer letter="A" count={12}>
                <FilterItems title="aaa" />
                <FilterItems />
              </FilterGroupContainer>
              <FilterGroupContainer letter="A" count={12}>
                <FilterItems title="aaa" />
                <FilterItems />
              </FilterGroupContainer> */}
            </Container>
          </TabPanel>
          <Container className={classes.bottomButtonContainer}>
            <Button
              variant="contained"
              color="primary"
              style={{
                paddingLeft: props.loading ? "12px" : "16px",
                width: "100%",
              }}
              onClick={() => {
                props.addRemoveFilter(selectedFilters);
              }}
            >
              Apply Filters
            </Button>
          </Container>
        </Menu>
      </ClickAwayListener>
    </div>
  );
}

const useStyles = makeStyles({
  printButtonText: {
    textTransform: "none",
  },
  buttonText: {
    textTransform: "none",
  },
  buttonIcon: {
    width: "18px",
    height: "18px",
    marginRight: 8,
  },
  titleContainer: {
    minWidth: 320,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 24,
    paddingBottom: 16,
  },
  buttonContainer: {
    paddingLeft: 6,
    paddingRight: 6,
    paddingTop: 6,
  },
  bottomButtonContainer: {
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 8,
    paddingBottom: 24,
  },
  tabContainer: {
    width: "100%",
    height: 376,
    maxWidth: 320,
    paddingLeft: 4,
    paddingRight: 4,
    "overflow-y": "auto",
  },
  header: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  textButton: {
    ...textButtonHoverAndActive
  },
  headerOrderDetailSection: {
    textAlign: "left",
    display: "flex",
    justifyContent: "center",
  },
  verticalAlignText: { display: "inline-block", verticalAlign: "middle" },
  verticalAlignTextArea: { display: "flex", alignItems: "center" },
});
